// extracted by mini-css-extract-plugin
module.exports =  {"form":"yKnAUxTzwWGpt4TW5ejc","header":"F2m1WDs24cjgKqGXUm9f","footer":"enlCefXWURNFSADFONfn","compact":"qZb4_EGqF_Lmt5yImCjC"};